<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">用户反馈意见</div>
          <span class="m-title-s">对用户反馈意见管理等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-form :inline="true" size="small" :model="searchForm" ref="searchForm">
          <el-form-item label="注册电话:">
            <el-input type="number" size="small" v-model="searchForm.userPhone"  placeholder="搜索注册电话" />
          </el-form-item>
          <el-form-item label="反馈电话:">
            <el-input type="number" size="small" v-model="searchForm.phone"  placeholder="搜索反馈电话" />
          </el-form-item>
          <el-form-item style="margin-left: 30px;">
            <el-button type="primary" size="small" @click="search(searchForm.status)">搜索</el-button>
            <el-button type="primary" size="small" plain @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
        <el-container class="m-table-opt">
          <div @click="listData('0')" :class="searchForm.status === '0' ? 'm-table-opt-this' : ''" class="m-table-opt-btn">未回复</div>
          <div @click="listData('1')" :class="searchForm.status === '1' ? 'm-table-opt-this' : ''" class="m-table-opt-btn">已回复</div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="small">
          <el-table-column prop="userPhone" label="注册电话" width="130" align="center"></el-table-column>
          <el-table-column prop="phone" label="反馈电话" width=""></el-table-column>
          <el-table-column prop="nickname" label="用户昵称" width=""></el-table-column>
          <el-table-column prop="opinion" label="反馈意见" width=""></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="" align="center"></el-table-column>
          <el-table-column v-if="searchForm.status === '1'" prop="remarks" label="回复内容" width="" align="center"></el-table-column>
          <el-table-column prop="status" label="回复状态" width="" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '0'" type="danger">未回复</el-tag>
              <el-tag v-if="scope.row.status === '1'" type="success">已回复</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>回复</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="详细信息" :visible.sync="openState" @close='closeDialog' center width="500px" :close-on-click-modal="false">
      <div v-loading="formLoading">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item label="用户反馈: " prop="opinion">
            <div class="m-user-open" style="line-height: 26px;">
              {{ form.opinion }}
            </div>
          </el-form-item>
          <el-form-item label="回复内容: " prop="remarks">
            <el-input v-model="form.remarks" type="textarea" placeholder="输入回复内容"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;width: 100%;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'userOpinion',
  data () {
    return {
      openState: false,
      formLoading: false,
      isLoading: true,
      list: [],
      total: 0,
      searchForm: {
        status: '0',
        userPhone: '',
        phone: '',
        pageNo: 1
      },
      form: {
        id: '',
        opinion: '',
        remarks: ''
      },
      rules: {
        remarks: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    resetForm () {
      this.searchForm = {
        status: this.searchForm.status,
        userPhone: '',
        phone: '',
        pageNo: 1
      }
      this.listData(this.searchForm.status)
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData(this.searchForm.status)
    },
    closeDialog () {
      this.form = {
        id: '',
        opinion: '',
        remarks: ''
      }
      this.formLoading = false
    },
    openForm (row) {
      this.form = row
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/app/opinion/saveStatus', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.openState = false
                _this.listData(_this.searchForm.status)
              } else {
                _this.$message.error(res.msg)
              }
              _this.formLoading = false
            })
        } else {
          return false
        }
      })
    },
    search (status) {
      this.searchForm.pageNo = 1
      this.listData(status)
    },
    // 用户列表
    listData (status) {
      let _this = this
      this.isLoading = true
      this.searchForm.status = status
      _this.list = []
      this.$axios.post('/app/opinion/list', _this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData('0')
  }
}
</script>

<style scoped src="../../assets/css/user.css"></style>



// WEBPACK FOOTER //
// src/components/user/UserOpinion.vue